import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/stores/amazon-appstore.svg")